import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hide Emergent Badge
const hideEmergentBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; width: 0 !important; height: 0 !important; position: absolute !important; left: -99999px !important;';
    badge.remove();
  }
};

// Run immediately and on DOM changes
hideEmergentBadge();
document.addEventListener('DOMContentLoaded', hideEmergentBadge);
setTimeout(hideEmergentBadge, 100);
setTimeout(hideEmergentBadge, 500);
setTimeout(hideEmergentBadge, 1000);

// Observe DOM for badge insertion
const observer = new MutationObserver(hideEmergentBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
